import { errorTextStyles as e, formHelperTextStyles as t, formLabelStyles as n, formRootStyles as r } from "../shared/form-primitives.js";
import { cva as i } from "class-variance-authority";
// src/design/forms/text-area/style.ts
var a = r, o = n, s = i([
	"flex w-full rounded-md border border-input-border bg-input-background",
	"text-sm text-foreground placeholder:font-normalx placeholder:text-muted-foreground/60",
	"transition-all duration-normal resize-y",
	"focus-visible:outline-hidden focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
	"hover:bg-muted",
	"read-only:cursor-default read-only:bg-muted read-only:resize-none",
	"data-[invalid]:border-destructive data-[invalid]:focus-visible:border-destructive data-[invalid]:focus-visible:ring-destructive/50",
	"disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted disabled:resize-none",
	"[&::-webkit-resizer]:appearance-none",
	"[&::-webkit-resizer]:w-3 [&::-webkit-resizer]:h-3",
	"[&::-webkit-resizer]:rounded-br-[3px]",
	"[&::-webkit-resizer]:bg-[linear-gradient(135deg,transparent_0%,transparent_calc(50%-0.5px),var(--border)_calc(50%-0.5px),var(--border)_calc(50%+0.5px),transparent_calc(50%+0.5px),transparent_calc(68%-0.5px),var(--border)_calc(68%-0.5px),var(--border)_calc(68%+0.5px),transparent_calc(68%+0.5px),transparent_calc(86%-0.5px),var(--border)_calc(86%-0.5px),var(--border)_calc(86%+0.5px),transparent_calc(86%+0.5px))]",
	"[&::-webkit-resizer]:cursor-nwse-resize"
], {
	variants: {
		size: {
			sm: "min-h-[60px] px-2.5 py-1.5 text-sm",
			md: "min-h-[80px] px-3 py-2",
			lg: "min-h-[120px] px-4 py-3 text-base"
		},
		resize: {
			none: "resize-none",
			vertical: "resize-y",
			horizontal: "resize-x",
			both: "resize"
		}
	},
	defaultVariants: {
		size: "md",
		resize: "vertical"
	}
}), c = t, l = e, u = i("text-destructive ml-0.5"), d = i("text-xs text-muted-foreground text-right", {
	variants: { limitReached: {
		true: "text-destructive font-medium",
		false: ""
	} },
	defaultVariants: { limitReached: !1 }
}), f = (e) => ({
	root: (e) => a(e),
	label: (e) => o(e),
	textarea: () => s({
		size: e?.size,
		resize: e?.resize
	}),
	helperText: () => c(),
	errorText: () => l(),
	requiredIndicator: () => u(),
	characterCount: (e) => d({ limitReached: e })
});
export { d as characterCountStyles, l as errorTextStyles, f as getStyles, c as helperTextStyles, o as labelStyles, u as requiredIndicatorStyles, a as rootStyles, s as textareaStyles };

//# sourceMappingURL=style.js.map